@if (!closed) {
  <div
    class="alert"
    [ngClass]="'alert-' + type">
    <span class="alert-message">
      <ng-content></ng-content>
    </span>
    @if (showCloseButton) {
      <button
        class="close-btn"
        (click)="closeAlert()">
        X
      </button>
    }
  </div>
}
